import type { BaseKeyFunction } from "../../../../lib";

export type KeyCommunityMembersProps = {
  id: number;
};

export const keyCommunityMembers: BaseKeyFunction<KeyCommunityMembersProps> = ({
  id,
}) => ["communities-members", id.toString()];
